const animItems = [
    // Главная
    {
        selector: '.hero',
        targets: [
            '.hero__bg',
            {
                selector: 'h1',
                delayBase: 0.2,
                anim: 'animate__fadeInLeft',
                // delayStep: .1
            },
            {
                selector: '.btn',
                delayBase: 0.4,
                anim: 'animate__fadeInLeft',
                // delayStep: .1
            },
            {
                selector: '.hero__easy',
                delayBase: 0.6,
                // anim: 'animate__fadeInLeft'
                // delayStep: .1
            },
        ],
        once: true
    },
    {
        selector: '.main-page .main-who-we-are',
        once: true,
        targets: [
            {
                selector: '.block-text > *',
                delayBase: 0.2,
                anim: 'animate__fadeInLeft',
                delayStep: 0.1
            },
            {
                selector: '.video-preview',
                delayBase: 0.6
            }
        ]
    },
    {
        selector: '.main-page .main-where-is-used .row',
        once: true,
        targets: [
            {
                selector: '.col,.col-12',
                delayBase: 0.2,
                delayStep: 0.2
            }
        ]
    },
    {
        selector: '.main-page .main-how-it-works',
        once: true,
        targets: [
            'h2',
            {
                selector: '.col-12,.col',
                delayBase: 0.3,
                delayStep: 0.1
            }
        ]
    },
    {
        selector: '.main-page .main-products',
        once: true,
        targets: [
            'h2',
            {
                selector: '.main-products__item',
                delayBase: 0.2,
                delayStep: 0.2
            }
        ]
    },
    {
        selector: '.main-page .main-news',
        once: true,
        targets: [
            {
                selector: '.block-text > *',
                delayBase: 0.1,
                delayStep: 0.1,
                anim: 'animate__fadeInLeft'
            },
            {
                selector: '.main-news__slider',
                delayBase: 0.5
            }
        ]
    },
    {
        selector: '.main-page .main-delivery',
        once: true,
        targets: [
            {
                selector: '.col-12,.col',
                delayBase: 0.1,
                delayStep: 0.2
            }
        ]
    },
    {
        selector: '.main-page .main-clients',
        once: true,
        targets: [
            'h2',
            {
                selector: '.col-12,.col',
                delayBase: 0.1,
                delayStep: 0.2
            }
        ]
    },
];

export default animItems;